<template>
  <v-app>    

    <router-view class="view" v-slot="{ Component }">
        <transition name="animation" enter-active-class="animated fadeIn">
          <component :is="Component" />
        </transition>
      </router-view>

    <Footer />
  
  </v-app>
</template>

<script>
import Navbar from './views/Navbar.vue'
import Footer from './views/Footer.vue'


export default {
  components: { Navbar, Footer},
  name: 'App',

  data: () => ({
    //
  }),
};
</script>

<style>

.content {
  padding-top: 60px;
  text-align: center;
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>
